
// const AppURL = 'http://192.168.2.14:3000';

const AppURL = 'https://loniceraback-t8pvb.ondigitalocean.app';

// git init  
// git remote add origin https://github.com/OuafidHabchi/Lonicera.git
// git remote -v    
// git checkout -b Web_vfinaleVf.3.0
// git add .  
// git commit -m "Ajout de la version statique Web_vfinaleVf.3.0"     
// git push -u origin Web_vfinaleVf.3.0  --force    

// npm run build


export default AppURL;
